// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"139":"08888d87","543":"2ca99f87","912":"08888d87"}[chunkId] + ".chunk.css";
};